import React from 'react';
import cn from 'classnames';

import './pagination.scss';
import arrow from '../../assets/illustrations/arrow.svg';
import points from '../../assets/illustrations/pagination.svg';

const pageThreshold = 3;

const Pagination = ({
	skip = 0, total, limit, changeCallback,
}) => {
	let currentPage = parseInt(skip, 10);
	const amountOfPages = Math.ceil(total / limit);
	const li = [];

	if (currentPage === 0) {
		currentPage = 1;
	}

	if (amountOfPages === 1 || amountOfPages === 0) {
		return null;
	}

	if (amountOfPages > pageThreshold) {
		li.push(
			<li
				className={cn({ active: currentPage === 1 })}
				onClick={() => changeCallback(1)}
				key="1">
				1
			</li>,
		);
		if (currentPage < pageThreshold + 1) {
			for (let i = 2; i <= pageThreshold; i += 1) {
				li.push(
					<li
						className={cn({ active: i === currentPage })}
						onClick={() => changeCallback(i)}
						key={i}
					>
						{i}
					</li>,
				);
			}
			li.push(
				<li className="disabled">
					<img src={points} alt="" aria-hidden />
				</li>,
			);
		} else if (currentPage < amountOfPages - pageThreshold + 1) {
			li.push(
				<li className="disabled" key="points1">
					<img src={points} alt="" aria-hidden />
				</li>,
			);
			li.push(
				<li className="active" onClick={() => changeCallback(currentPage)}>
					{currentPage}
				</li>,
			);
			li.push(
				<li className="disabled" key="points2">
					<img src={points} alt="" aria-hidden />
				</li>,
			);
		} else {
			li.push(
				<li className="disabled" key="points_disable">
					<img src={points} alt="" aria-hidden />
				</li>,
			);
			for (
				let i = amountOfPages - pageThreshold + 1;
				i < amountOfPages;
				i += 1
			) {
				li.push(
					<li
						className={cn({ active: i === currentPage })}
						onClick={() => changeCallback(i)}
						key={i}
					>
						{i}
					</li>,
				);
			}
		}
	} else {
		for (let i = 1; i < amountOfPages; i += 1) {
			li.push(
				<li
					className={cn({ active: i === currentPage })}
					onClick={() => changeCallback(i)}
				>
					{i}
				</li>,
			);
		}
	}
	li.push(
		<li
			className={cn({ active: currentPage === amountOfPages })}
			onClick={() => changeCallback(amountOfPages)}
		>
			{amountOfPages}
		</li>,
	);

	return (
		<section className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div className="pages">
				<ul>
					<li
						onClick={() => changeCallback(currentPage - 1)}
						className={cn('arrow', { disabled: currentPage === 1 })}
					>
						<img
							className="footer-illustration left-arrow"
							src={arrow}
							alt=""
							aria-hidden
						/>
					</li>
					{li}
					<li
						onClick={() => changeCallback(currentPage + 1)}
						className={cn('arrow', { disabled: currentPage === amountOfPages })}
					>
						<img
							className="footer-illustration right-arrow"
							src={arrow}
							alt=""
							aria-hidden
						/>
					</li>
				</ul>
			</div>
		</section>
	);
};

export default Pagination;
